import { CONFIG } from '../../core/config';
import { ViewModel } from '../view-model';
import { EquipmentItem } from './equipment-item';

export class EquipmentComponent implements ViewModel, EquipmentItem {
  readonly friendlyTypeNameSingular = 'Equipment Component';
  readonly apiRoute: string = CONFIG.apiRoutes.equipmentComponent;
  id: string;
  name: string;
  identifier: string;
  json() {
    return {
      id: this.id,
      name: this.name,
      identifier: this.identifier,
    };
  }

  public loadFromJson(data) {
    this.id = data.id;
    this.name = data.name;
    this.identifier = data.identifier;
  }
}
